import {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  HideOnPdfToggle,
  StandardDesignConfig,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const HiddenToggle = {
  label: 'Hidden',
  settingType: 'toggleInput',
  updateType: 'entry',
  property: 'visible',
  choices: [
    { value: false, previousValue: true, additionalProps: { required: false } },
    { value: true, previousValue: false },
  ],
  tooltip:
    'Hidden fields are not visible to the person filling out the app. Useful for automatically capturing things like GPS location, date, and time.',
}

const GPSDisplaySelect = {
  label: 'Display',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'gps_display_type',
  choices: [
    {
      label: 'Small Map',
      value: 0,
    },
    {
      label: 'Large Map',
      value: 1,
    },
    {
      label: 'Lat/Long',
      value: 2,
    },
    {
      label: 'Map Link',
      value: 3,
    },
  ],
}

const GPSZoomSelect = {
  label: 'Map Zoom',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'zoom_level',
  isDisabled: ({ gps_display_type }) => gps_display_type > 1,
  choices: [
    {
      label: 'Farthest (State)',
      value: 0,
    },
    {
      label: 'Farther',
      value: 1,
    },
    {
      label: 'Far',
      value: 2,
    },
    {
      label: 'Middle (City)',
      value: 3,
    },
    {
      label: 'Close',
      value: 4,
    },
    {
      label: 'Closer (Street)',
      value: 5,
    },
    {
      label: 'Closest',
      value: 6,
    },
  ],
}

export const GPSStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  GPSDisplaySelect,
  GPSZoomSelect,
  { ...RequiredToggle, isDisabled: ({ visible }) => !visible },
  HiddenToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
